module.exports = require('../../full/promise/finally');
